
import {createSlice} from "@reduxjs/toolkit";


export const uploadFileSlice = createSlice({
    name: 'uploadFileSlc',
    initialState: {value: {
            uploadFileDrawerState: false, uploadFileDrawerMode: null}},
    reducers:
        {
            changeUploadFile: (state, action) => {
                state.value = action.payload;
            },
        }
});

export const { changeUploadFile } = uploadFileSlice.actions;

export default  uploadFileSlice.reducer ;

